import React from 'react';
import PropTypes from 'prop-types';

export default function ArrowIcon(props) {
  const { fill, size, direction } = props;

  function getRotationAngle(direction) {
    const angles = {
      left: '0',
      right: '180',
      up: '90',
      down: '270'
    };

    return angles[direction] !== undefined ? angles[direction] : '0';
  }

  const rotate = getRotationAngle(direction);

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 20 20'
      transform={`rotate(${rotate})`}
    >
      <path fill='none' d='M0 0h20v20H0z' data-name='Retângulo 148017' />
      <path
        fill={fill}
        d='M13.5 19a1.454 1.454 0 0 1-1.061-.465l-7-7.412a1.655 1.655 0 0 1 0-2.246l7-7.412a1.441 1.441 0 0 1 2.121 0 1.655 1.655 0 0 1 0 2.246L8.621 10l5.939 6.289a1.655 1.655 0 0 1 0 2.246A1.454 1.454 0 0 1 13.5 19Z'
        data-name='Caminho 102907'
      />
    </svg>
  );
}

ArrowIcon.defaultProps = {
  size: '20',
  fill: '#4b4b4b',
  direction: 'left'
};

ArrowIcon.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.string,
  direction: PropTypes.oneOf(['left', 'up', 'right', 'down'])
};
